import * as React from "react";

type FocusHandlers = {
  onOpenAutoFocus?: (event: Event) => void;
  onCloseAutoFocus?: (event: Event) => void;
};

/**
 * Focus goes back to what had it when a dialog opened. Radix returns it to the dialog's Trigger;
 * a dialog opened from state (no Trigger) left it on <body>, and a keyboard user started again at
 * the top of the page (QA-0023). Used by DialogContent, SheetContent and AlertDialogContent.
 */
export function useReturnFocus({ onOpenAutoFocus, onCloseAutoFocus }: FocusHandlers) {
  const opener = React.useRef<HTMLElement | null>(null);
  return {
    onOpenAutoFocus: (event: Event) => {
      const active = document.activeElement;
      opener.current = active instanceof HTMLElement && active !== document.body ? active : null;
      onOpenAutoFocus?.(event);
    },
    onCloseAutoFocus: (event: Event) => {
      onCloseAutoFocus?.(event);
      // A menu item that opened it is gone by now: then Radix decides, as before.
      if (event.defaultPrevented || !opener.current?.isConnected) return;
      event.preventDefault();
      opener.current.focus();
    },
  };
}
